import type { Employee } from "@/types/domain";

/** Monthly new-hire counts for the last `months` months, derived entirely
 * from real joining dates on the already-fetched roster page - not a
 * historical headcount trend (this system has no month-by-month headcount
 * snapshot to draw one from truthfully), but a genuinely real, accurate
 * "hiring trend" occupying the same slot. See DashboardPage's own note on
 * why this is the honest substitute for the reference's headcount line. */
export function buildHiringTrend(employees: Employee[], months = 6): { label: string; hires: number }[] {
  const now = new Date();
  const buckets: { key: string; label: string; hires: number }[] = [];
  for (let i = months - 1; i >= 0; i--) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    buckets.push({
      key: `${d.getFullYear()}-${d.getMonth()}`,
      label: d.toLocaleDateString(undefined, { month: "short" }),
      hires: 0,
    });
  }
  const byKey = new Map(buckets.map((b) => [b.key, b]));
  for (const employee of employees) {
    if (!employee.joining_date) continue;
    const joined = new Date(employee.joining_date);
    const key = `${joined.getFullYear()}-${joined.getMonth()}`;
    const bucket = byKey.get(key);
    if (bucket) bucket.hires += 1;
  }
  return buckets.map(({ label, hires }) => ({ label, hires }));
}
